import { selectMemberMgmtOpen } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useMemberMgmtOpen = () => useSelector(selectMemberMgmtOpen);

export default useMemberMgmtOpen;
